export function klasifikujPritisak(sistolni, dijastolni) {
  const s = Number(sistolni);
  const d = Number(dijastolni);

  if (s < 120 && d < 80) return { label: 'Normalan', klasa: 'badge-normal', statusKlasa: 'status-normal' };
  if ((s >= 120 && s <= 129) && d < 80) return { label: 'Povišen', klasa: 'badge-elevated', statusKlasa: 'status-elevated' };
  if ((s >= 130 && s <= 139) || (d >= 80 && d <= 89)) return { label: 'Visok I', klasa: 'badge-high', statusKlasa: 'status-high' };
  if (s >= 140 || d >= 90) return { label: 'Visok II', klasa: 'badge-very-high', statusKlasa: 'status-high' };
  return { label: 'Nepoznat', klasa: 'badge-elevated', statusKlasa: '' };
}

export function formatDatum(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleString('sr-RS', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
}
